import { childFileType, childFolderType } from "../../redux/fileManager/fileManagerTypes";

export const SELECT_FOLDER = 'select-folder';
export const UPDATE_FOLDER = 'update-folder';
export const SET_CHILD_FOLDERS = 'set-child-folders';
export const SET_CHILD_FILES = 'set-child-files';

export type folderType = {
  name: string;
  id: number | null;
  full_path: string | undefined;
}

export type initialStateType = {
  folderId: number | null;
  folder: folderType;
  childFolders: [];
  childFiles: [];
}

interface selectFolder {
  type: typeof SELECT_FOLDER;
  payload: {
    folderId: number | null,
    folder: folderType,
    childFolders: [],
    childFiles: []
  };
};

interface updateFolder {
  type: typeof UPDATE_FOLDER;
  payload: {
    name: string;
    id: number | null;
    path: []
  }
};

interface setChildFolders {
  type: typeof SET_CHILD_FOLDERS;
  payload: [] | childFolderType[];
};

interface setChildFiles {
  type: typeof SET_CHILD_FILES;
  payload: [] | childFileType[];
}

export type useFolderType =
  | selectFolder
  | updateFolder
  | setChildFolders
  | setChildFiles